// Shim for bootstrap-vue icon components → Bootstrap Icons CSS
// Maps <b-icon-*> component names to <i class="bi bi-*"> elements
import { h } from 'vue';

const iconMap = {
    'b-icon-arrow-counterclockwise': 'bi-arrow-counterclockwise',
    'b-icon-arrow-down-up': 'bi-arrow-down-up',
    'b-icon-bar-chart-fill': 'bi-bar-chart-fill',
    'b-icon-check': 'bi-check',
    'b-icon-chevron-down': 'bi-chevron-down',
    'b-icon-chevron-right': 'bi-chevron-right',
    'b-icon-chevron-up': 'bi-chevron-up',
    'b-icon-dash-circle': 'bi-dash-circle',
    'b-icon-grip-vertical': 'bi-grip-vertical',
    'b-icon-info-circle': 'bi-info-circle',
    'b-icon-pencil-square': 'bi-pencil-square',
    'b-icon-plus': 'bi-plus',
    'b-icon-plus-circle': 'bi-plus-circle',
    'b-icon-trash': 'bi-trash',
    'b-icon-x': 'bi-x',
};

function toPascalCase(kebab) {
    return kebab.split('-').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join('');
}

export default {
    install(app) {
        Object.entries(iconMap).forEach(([componentName, iconClass]) => {
            const iconComponent = {
                inheritAttrs: false,
                render() {
                    return h('i', {
                        class: ['bi', iconClass, this.$attrs.class],
                        style: this.$attrs.style
                    });
                }
            };
            // Register both kebab-case and PascalCase
            app.component(componentName, iconComponent);
            app.component(toPascalCase(componentName), iconComponent);
        });
    }
};
